export default "__VITE_ASSET__DZUEb$Mr__"